import { useTranslation } from "react-i18next";

import { Button } from "@/shared/ui/Button";
import { ProblemNotice } from "@/shared/ui/ProblemNotice";

/** What a person sees when a page could not be shown. */
export function ErrorScreen({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="mx-auto flex max-w-lg flex-col items-start gap-3 p-6">
      <h1 className="text-xl font-semibold">{t("errors.title")}</h1>
      <ProblemNotice error={error} />
      {onRetry && <Button onClick={onRetry}>{t("common.retry")}</Button>}
    </div>
  );
}
